import HeaderCrudBordero from './HeaderCrudBordero';

export default HeaderCrudBordero;
